export default "__VITE_ASSET__b4a043b6__"